import React, { useState } from "react";
import "./SilverInvestmentDetails.css";
import { Formik, Form } from "formik";
import { BankTranferDetailsTextInput } from "../../../../../../Formik/BankDetailsInput";
import * as Yup from "yup";
import { Util } from "../../../../../../../../helpers/util";
import {
  INVESTMENT_PLAN,
  INVEST_OPTIONS,
} from "../../../../../../../../constants";
import { toast } from "react-toastify";

const StartInvestment = ({ setPage }) => {
  const pkg = Util.get(INVESTMENT_PLAN);
  const [estimatedReturns, setEstimatedReturns] = useState(0);
  const [amount, setAmount] = useState("");
  const [returnType, setReturnType] = useState("end_of_investment");

  const handleAmountChange = (event) => {
    const { value } = event.target;

    const estimatedReturns = +value + (+value * pkg.total_roi) / 100;

    setAmount(+value);
    setEstimatedReturns(+(estimatedReturns || +value).toFixed(2));
  };

  const handleReturnTypeChange = (event) => {
    const { value } = event.target;

    setReturnType(value);
  };

  if (!pkg) {
    return null;
  }

  const { currency } = Util.getCurrency();

  return (
    <div className="startinvestment">
      <div className="startinvestment-body">
        <h5 className="startinvestment-h5"> Invest</h5>
        <p className="startinvestment-textbody">
          Invest in {pkg.package_name} and earn {pkg.total_roi}% interest in{" "}
          {Math.round(pkg.period / 30)} months
        </p>
        <div className="amountinvest">
          <p className="amount-p">How much would you like to invest?</p>
          <Formik
            initialValues={{
              amount: amount,
            }}
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
            }}
            validationSchema={Yup.object({
              // amount: Yup.string().required(
              //   "Amount deposited Field is required"
              // ),
            })}
          >
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="amount"
                  type="tel"
                  placeholder={currency}
                  onChange={handleAmountChange}
                  value={amount}
                />
              </Form>
            )}
          </Formik>
          <p className="minimum-amount">
            Minimum amount:{ currency}{(pkg.min || 0).toLocaleString()}
          </p>
        </div>
        <div className="radiobutton">
          <input
            type="radio"
            checked={returnType === "end_of_investment"}
            id="end_of_investment"
            onChange={handleReturnTypeChange}
            value="end_of_investment"
            className="radio-input"
          />
          <label htmlFor="end_of_investment" className="enquiry-label">
            Prefer ROI to be disbursed after investment cycle
          </label>
          <br />
        </div>
        <div className="radiobutton">
          <input
            type="radio"
            id="monthly"
            checked={returnType === "monthly"}
            onChange={handleReturnTypeChange}
            value="monthly"
            className="radio-input2"
          />
          <label htmlFor="monthly" className="enquiry-label2">
            Prefer ROI to be disbursed every month
          </label>
        </div>
        <div className="interest-rate">
          <div className="interest-flex">
            <p>Interest Rate</p>
            <p>{pkg.total_roi}%</p>
          </div>
          <div className="interest-flex">
            <p>Estimated Returns</p>
            <p>{estimatedReturns.toLocaleString()}</p>
          </div>
        </div>
        <button
          type="submit"
          className="invest"
          onClick={() => {
            if (amount < +pkg.min) {
              toast.error(
                `Minimum investment amount is ${(
                  pkg.min || 0
                ).toLocaleString()}`
              );
              return;
            }

            Util.set(INVEST_OPTIONS, {
              ...pkg,
              amount,
              returnType,
              estimatedReturns,
              duration: Math.round(pkg.period / 30),
              interestRate: pkg.total_roi,
              packageId: pkg.id,
              lastMonthRoi: pkg.last_month_roi,
              monthlyRoi: pkg.monthly_roi,
            });
            setPage(2);
          }}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};
export default StartInvestment;
